import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function SkeletonElement(_ref) {
  var type = _ref.type,
    size = _ref.size;
  var addCssByType = function addCssByType() {
    switch (type) {
      case "title":
        return "w-[50%] h-4";
      case "text":
        return "w-full h-3";
      case "circle":
        return "w-24 h-24 rounded-full";
      case "thumbnail":
        return "w-24 h-24 ";
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: " bg-[#ddd] rounded-lg my-2 animate-pulse ".concat(size ? size : addCssByType())
  });
}
export default SkeletonElement;